<div class="ranking-list-item" *ngIf="item">
  <div class="ranking-list-item__position" [attr.data-position]="item.position">{{item.position}}</div>

  <div class="ranking-list-item__position-change">
    <brt-icon [icon]="item.difference == 'NEGATIVE' ? 'dropdown' : 'dropup'" *ngIf="item.difference !== 'NONE'"></brt-icon>
  </div>

  <div class="ranking-list-item__image">
    <brt-game-organization-logo [name]="item.schoolClassData.name"></brt-game-organization-logo>
  </div>

  <div class="ranking-list-item__data">
    <div class="ranking-list-item__title">{{item.schoolClassData.schoolName}}</div>
    <div class="ranking-list-item__time-played"><brt-icon [icon]="'time'"></brt-icon> {{playedTimeString}}</div>
  </div>

  <div class="ranking-list-item__points">{{item.points | number:'.'}}</div>
</div>
